import registerWebComp from '@helsenorge/framework-utils/web-component/register';

import PersonvelgerCms from './components/personvelger-cms';
import PersonvelgerComponent from './components/personvelger-component';
import PersonvelgerTjenester from './components/personvelger-tjenester';
import Session from './components/session';

const templateId = 'hn-webcomp-personvelger-template';

async function enableMocking(): Promise<ServiceWorkerRegistration | void> {
  if (import.meta.env.MODE !== 'mocks') {
    return;
  }

  const { worker } = await import('./__mocks__/browser');

  return worker.start({
    onUnhandledRequest: 'bypass',
  });
}

enableMocking().then(() => {
  //Brukt som html-tag direkte framework via entrypage. Som betyr at den må være consumed i html-en fra serveren. Lagt til under basepage i pageConfiguration i HN-Tjenester
  registerWebComp(PersonvelgerTjenester, { name: 'hn-webcomp-personvelger', templateId });
  //WebCompConsumer i microweb: header-footer under menu-profile
  registerWebComp(PersonvelgerComponent, { name: 'hn-webcomp-personvelger-component', templateId });
  //Brukt som html-tag direkte via cms-et (HN-CMS). Consumed i html-en fra serveren ved id: hn-webcomp-personvelger-template
  //Tror path til hvor assets ligger på server må settes i spesufikt for cms-et ved HN-CMS/Source/Helsenorge/Features/Shared/Services/WebComponentAssetsService.cs
  registerWebComp(PersonvelgerCms, { name: 'hn-webcomp-personvelger-cms', templateId });
  //WebCompConsumer i microweb: header-footer under header-wrapper.
  registerWebComp(Session, { name: 'hn-webcomp-session', templateId });
});
